import React                  from 'react';
import { Observe }                 from 'rewire-core';
import { Form, FormView, Modal }   from 'rewire-ui';
import EditDialogModel             from '../schedule/EditDialogModel';
import timeOffBalancesDialogModel  from '../schedule/TimeOffBalancesDialogModel';
import EmployeeFieldsView          from './EmployeeFieldsView';
import employeeViewTypeModel       from './EmployeeViewTypeModel';
import SettingsModel, { useWatch } from './SettingsModel';
import TimeOffBalancesView         from './TimeOffBalancesView';

export const EmployeeEditorContentsView = React.memo(({ model, showBalances = true}: { model: Modal & {form: Form}, showBalances?: boolean }) => {
  return (
    <FormView form={model.form} onSubmit={model.actionFn('save')}>
      <Observe render={() => {
        return !showBalances || employeeViewTypeModel.isView('details')
          ? <EmployeeFieldsView fields={model.form.fields} />
          : <TimeOffBalancesView />;
      }} />
    </FormView>
  );
});

const EmployeeEditorView = React.memo(({ editor, settings }: { editor: EditDialogModel, settings: SettingsModel }) => {
  useWatch(
    () => {
      settings.selectedItem;
      employeeViewTypeModel.isView('balances');
    },
    () => employeeViewTypeModel.isView('balances') &&
          timeOffBalancesDialogModel.loadTimeOffTypes(settings.selectedItem?.id)
  );

  return (
    <EmployeeEditorContentsView model={editor} />
  );
});

export default EmployeeEditorView;
